import { render, staticRenderFns } from "./PublishLoading.vue?vue&type=template&id=a9d6b9dc&scoped=true"
import script from "./PublishLoading.vue?vue&type=script&lang=js"
export * from "./PublishLoading.vue?vue&type=script&lang=js"
import style0 from "./PublishLoading.vue?vue&type=style&index=0&id=a9d6b9dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d6b9dc",
  null
  
)

export default component.exports